import { Component, OnInit } from '@angular/core';
import { UserAuthentication } from '../../_models';
import { authenticaitonModel } from '../authentication/model/authenticaiton.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  currentUser: authenticaitonModel;
  users: UserAuthentication[] = [];

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }
  }

  loggedUser(): boolean {
    var currentUser: authenticaitonModel = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      return true;
    } else {
      return false
    }
  }
}
